import { Input } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { IS_FOREIGN } from '../../Cfmp.constants'
import { Container, Item } from '../../Cfmp.styles'
import { inputShape, selectFieldShape } from './CfmpForm.propTypes'

/**
 * The CfmpFormSupplierIdentification component.
 */
export const CfmpFormSupplierIdentification = ({
  isDisabled = false,
  isSourcesLoading = false,
  procedureType,
  reasonType,
  supplierName,
  supplierRut
}) => {
  const isForeign =
    reasonType.input.value === IS_FOREIGN.CAUSAL_VALUE ||
    procedureType.input.value === IS_FOREIGN.PROCEDURE_VALUE

  return (
    <Container spacing={2}>
      <Item size={{ md: 6, xs: 12 }}>
        <Input
          disabled={isDisabled}
          error={supplierRut.error}
          label={isForeign ? 'DNI' : 'RUT Proveedor'}
          loading={isSourcesLoading}
          maxLength={15}
          onChange={supplierRut.onChange}
          value={supplierRut.value}
        />
      </Item>

      <Item size={{ md: 6, xs: 12 }}>
        <Input
          disabled={isDisabled}
          error={supplierName.error}
          label="Nombre o razón social"
          loading={isSourcesLoading}
          maxLength={200}
          onChange={supplierName.onChange}
          value={supplierName.value}
        />
      </Item>
    </Container>
  )
}

CfmpFormSupplierIdentification.propTypes = {
  isDisabled: PropTypes.bool,
  isSourcesLoading: PropTypes.bool,
  procedureType: selectFieldShape.isRequired,
  reasonType: selectFieldShape.isRequired,
  supplierName: inputShape.isRequired,
  supplierRut: inputShape.isRequired
}
